import { removeCartCoupon } from '@vs-shop/engine/module/cart/cartOperations';

/** Removes a coupon through the shared Cart service. */
const removeCouponFromOrder = removeCartCoupon;

export default removeCouponFromOrder;
